module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-73-min.b81acb66.jpg";